import { useMutation } from '@tanstack/react-query';
import { useLegacyApi } from '@/hooks/useLegacyApi';

export function useViewCount(entryId: number) {
  const { apiClient } = useLegacyApi();
  const mutation = useMutation({ mutationFn: () => apiClient.patch(`/api/net-auctions/${entryId}/view-count`) });

  return {
    increment: mutation.mutate,
  };
}
